import { FISCAL_OFFSET_MAP } from 'ui-deal-management-components-lib/constants/FiscalConstants';
import { createSelector } from 'reselect';
import { getTimePeriodFilter } from './filtersSelectors';
import { SUCCEEDED } from '../constants/RequestStatusTypes';
import { DEAL_SPLITS_ENABLED, FISCAL_OFFSET, HAS_SETUP_FORECAST_CATEGORIES, STALE_SUBMISSION_FORECAST } from '../constants/SettingsTypes';
import { getTimePeriodOffset } from '../utils/dateUtils';
export const getPortalSettings = state => state.portalSettings;
export const getDealSplitsEnabled = state => getPortalSettings(state).get(DEAL_SPLITS_ENABLED);
export const getHasSetupForecastCategories = state => getPortalSettings(state).get(HAS_SETUP_FORECAST_CATEGORIES);
export const getHasPortalSettingsRequestCompleted = state => getPortalSettings(state).get('status') === SUCCEEDED;
export const getStaleSubmissionLimit = createSelector([getPortalSettings, getTimePeriodFilter], (portalSettings, timePeriod) => {
  const filterTimePeriodOffset = getTimePeriodOffset(timePeriod);
  const hasStaleSubmissionValue = portalSettings.get(STALE_SUBMISSION_FORECAST);
  //check that offset is 0 to ensure we're filtered to the current time period to show stale warning
  return hasStaleSubmissionValue && filterTimePeriodOffset === 0 ? portalSettings.get(STALE_SUBMISSION_FORECAST) : null;
});
export const getFiscalOffset = createSelector([getPortalSettings, getHasPortalSettingsRequestCompleted], (portalSettings, portalSettingsRequestCompleted) => {
  if (!portalSettingsRequestCompleted) {
    return 0;
  }
  const fiscalOffsetMonth = portalSettings.get(FISCAL_OFFSET);

  // Explicitly check for null and return undefined. This is the same functioinal
  // behavior as a null lookup on an object
  return fiscalOffsetMonth === null ? undefined : FISCAL_OFFSET_MAP[fiscalOffsetMonth];
});